import Vue from "vue";
import router from "@/router";
import store from "@/store";
import i18n from "@/i18n";
import App from "@/app.vue";

import VueResource from "vue-resource";
import Vuelidate from "vuelidate";
import VueSweetalert2 from "vue-sweetalert2";
import datePicker from "vue-bootstrap-datetimepicker";

import numeral from "numeral";
import dayjs from "dayjs-ext";
import timeZonePlugin from "dayjs-ext/plugin/timeZone";
import advancedFormat from 'dayjs-ext/plugin/advancedFormat';

import helpers from "@/plugins/helpers";

import VueAwesomeSwiper from "vue-awesome-swiper";
Vue.use(VueAwesomeSwiper);
import "swiper/css/swiper.css";

// vue tour components
import VueTour from "vue-tour";
require("vue-tour/dist/vue-tour.css");
Vue.use(VueTour);

Vue.config.productionTip = process.env.NODE_ENV === "production" || false;
Vue.use(Vuelidate);
Vue.use(VueResource);
Vue.use(VueSweetalert2);
Vue.use(datePicker);
Vue.use(helpers, { $store: store, $router: router, $swal: Vue.swal, $i18n: i18n });

dayjs.extend(timeZonePlugin);
dayjs.extend(advancedFormat);
// import moment from "moment-timezone";
// moment.tz.setDefault("Asia/Kuala_Lumpur");
// Object.defineProperty(Vue.prototype, "$moment", { value: moment });
Object.defineProperty(Vue.prototype, "$dayjs", { value: dayjs });
Object.defineProperty(Vue.prototype, "$numeral", { value: numeral });

Vue.prototype.$log = console.log;

/* eslint-disable no-new */

router.beforeEach((to, from, next) => {
  let query = to.fullPath.match(/^\/$/) ? {} : { redirect: to.fullPath };
  let path = "/";
  if (
    to.matched.some(record => {
      return record.meta.requiredLoggedIn;
    })
  ) {
    if (!store.getters.isLoggedIn) {
      if (next) {
        next({ path: path, query: query });
      }
      return;
    }
  }
  if (next) {
    try {
      next();
    } catch (err) {
      console.log(err);
    }
  }
});

// store.dispatch("user/restore");

export const app = new Vue({
  router,
  store,
  i18n,
  mounted() {
    this.$store.dispatch("layout/setLanguage", this.$store.getters.language);
  },
  render: h => h(App)
}).$mount("#app");
